import { Button } from '@goodneighbor/ui';
import { Grid01, List } from '@goodneighbor/ui/icons/untitled';
import styles from './eventControls.module.scss';
import { cx } from 'class-variance-authority';

export type EventControlsProps = {
  totalEvents: number;
  viewMode: 'grid' | 'list';
  onChangeViewMode: (mode: 'grid' | 'list') => void;
  className?: string;
};

export default function EventControls({
  totalEvents,
  viewMode,
  onChangeViewMode,
  className
}: EventControlsProps) {
  return (
    <div className={cx(styles.controls, className)}>
      <div className={styles.count}>{totalEvents} events available</div>
      <div className={styles.toggleContainer}>
        <Button
          color="secondary"
          onClick={() => onChangeViewMode('grid')}
          aria-label="Grid view"
          className={cx(
            styles.toggleButton,
            styles.toggleButtonLeft,
            viewMode === 'grid' && styles.active
          )}
          iconLeading={Grid01}
        />
        <Button
          color="secondary"
          onClick={() => onChangeViewMode('list')}
          aria-label="List view"
          className={cx(
            styles.toggleButton,
            styles.toggleButtonRight,
            viewMode === 'list' && styles.active
          )}
          iconLeading={List}
        />
      </div>
    </div>
  );
}
